import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

const GoogleSheetsNode = ({ data }) => {
  const rows = data.sheetData || [];

  return (
    <div className="google-sheets-node">
      <Handle type="target" position={Position.Top} />
      <div className="node-title">{data.title || 'Google Sheets'}</div>
      {rows.length ? (
        <table className="sheet-table">
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="node-content">No data</div>
      )}
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
};

export default memo(GoogleSheetsNode);
